import { render, staticRenderFns } from "./_base-user-data.vue?vue&type=template&id=18d4243e&scoped=true&"
import script from "./_base-user-data.vue?vue&type=script&lang=js&"
export * from "./_base-user-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4243e",
  null
  
)

export default component.exports